module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_2.84551976.pdf";